<template>
    <div v-show="props.infoList?.length && (props.infoList?.[0]?.extra || props.infoList?.[0]?.list)" class="design-requirement">
        <div class="design-text">
          <div class="title-box">
            <div class="title-icon"></div>
            <div class="title-text">{{ $t('design.orderDetail.designRequirement') || '设计需求' }}</div>
          </div>
          <div v-if="showViewImage" class="view-image" @click="viewImage">{{ $t('design.orderDetail.viewPreferenceImage') || '查看示意图'}}</div>
        </div>
        <div class="design-requirement-container" v-for="( requirement, index ) in requirementList" :key='index'>
        <div class="requirement-main">
            <div class="target-tooth" v-if="requirement.paramsList?.length || requirement.scanningRod?.length || requirement.guidedImplantSurgery?.length">{{ $t('design.orderDetail.targetTooth') || '目标牙位'}}-{{ toothNameMap[requirement.tooth] ? toothNameMap[requirement.tooth] : $transToothNumber(Number(requirement.tooth), props.dentalNotation) }}</div>
            <div class="params-main" v-if="requirement.paramsList?.length">
                <div class="params-container" v-for="item in requirement.paramsList" :key="item.preName">
                    <div class="params-div">
                        <div class="params-label">{{ item.preName }}</div>
                        <div class="params-value">{{ (item.preValue === '' || item.preValue === undefined) ? '-' : item.preValue }}<span v-if="item.preUnit && !(item.preValue === '' || item.preValue === undefined)">{{ item.preUnit }}</span></div>
                    </div>
                </div>
            </div>
            <!-- 扫描杆 -->
            <div v-if="requirement.scanningRod?.length" class="params-main">
                <div class="params-container" v-for="item in requirement.scanningRod" :key="item.preName">
                    <div class="params-div">
                        <div class="params-label">{{ $t(`design.preference.${item.preName}`) }}</div>
                        <div class="params-value">{{ item.preValue || '-' }}</div>
                    </div>
                </div>
            </div>
            <!-- 工具盒 -->
            <div v-if="requirement.guidedImplantSurgery?.length" class="params-main">
                <div class="params-container" v-for="item in requirement.guidedImplantSurgery" :key="item.preName">
                    <div class="params-div">
                        <div class="params-label">{{ $t(`design.preference.${item.preName}`) }}</div>
                        <div class="params-value">{{ item.preValue || '-' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <!-- <div class="content-box requirement-box">
          <div class="content-text design-content requirement-content">
            {{ info.designContent }}
          </div>
        </div> -->
      </div>
</template>

<script setup>
import { ref, defineProps, onMounted, nextTick, watch, computed, defineEmits } from 'vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { toothNameMap } from '../design/case/const';
import { $transToothNumber } from '../utils/common';
const { $t } = useLang("@shining3d/xl-design-order");

const props = defineProps({
    infoList: {
        type: Object,
        default: () => ([])
    },
    selectProduct: {
        type: String    
    },
    dentalNotation: {
        type: String
    },
    showViewImage: {
        type: Boolean,
        default: true
    }
});
const emits = defineEmits(['viewImage'])
const extraData = ref([])
const requirementList = ref([])
//查看示意图
const viewImage = () => {
  emits('viewImage');
}

watch(() =>props.infoList, (val) => {
    if( val ){
        requirementList.value = (val || []).map((item) =>{
            let extraData = {};
            let data = [];
            let paramsList = [];
            try{
                extraData = item?.extra ? JSON.parse(item?.extra || '') : {};
            } catch(e) {
                extraData = {};
                console.log(e)
            }
            paramsList = (item.list || []).filter((item) => item?.paramApp !== 1 );
            // 牙齿色号 
            if( props.selectProduct === 'prod_DSD'){
                paramsList.unshift({
                    preCode: 'dentalShadeCode',
                    preName: $t('design.preference.dentalShadeCode'),
                    preValue: extraData?.dentalShadeCode
                })
            } else if( props.selectProduct === 'prod_automated_simple_3d_model' ){
                // 自动化3d模型-模型标签
                paramsList.unshift({
                    preCode: 'modelLabel',
                    preName: $t('design.preference.modelLabel'),
                    preValue: extraData?.modelLabel
                })
            }
            // requirementList.value.push({
            //     tooth: item?.tooth,
            //     paramsList: paramsList
            // })

            //扫描杆
            let scanningRod = []
            if( extraData?.scanningRod ){
                Object.keys(extraData.scanningRod)?.forEach(key => {
                    scanningRod.push({
                        preName: key,
                        preValue: String(extraData?.scanningRod[key])
                    })
                });
            } 
            // 工具盒
            let guidedImplantSurgery =[]
            if( extraData?.guidedImplantSurgery ){
                Object.keys(extraData.guidedImplantSurgery)?.forEach(key => {
                    guidedImplantSurgery.push({
                        preName: key,
                        preValue: String(extraData?.guidedImplantSurgery[key])
                    })
                });
            } 
            // // 牙齿色号
            // let dentalShadeCode = ''
            // if( data?.dentalShadeCode ){
            //     dentalShadeCode: data.dentalShadeCode
            // }
            data = {
                scanningRod: scanningRod,
                guidedImplantSurgery: guidedImplantSurgery,
                tooth: item?.tooth,
                paramsList: paramsList
            }
            return data
        }).sort((a, b) => {
            // 按照牙号，['upJaw', 'lowerJaw'] 排序
            if (toothNameMap[a.tooth]) {
                if ( a.tooth > b.tooth ) {
                    return -1;
                } else if ( a.tooth < b.tooth ){
                    return 1;
                } 
                return 0;
            } else {
                const aNum = $transToothNumber(Number(a.tooth), props.dentalNotation);
                const bNum = $transToothNumber(Number(b.tooth), props.dentalNotation);
                return aNum - bNum;
            }
        });
    }
    
},{ immediate: true} )

// onMounted(() => {
//     props.infoList.forEach((item) => {
//         try{
//             item.extra = JSON.parse(item.extra);
//         } catch(error) {
//             item.extra = ''
//             console.log(error);
//         }
//         console.log( item, 'item====')
//     })
//     nextTick(() => {
//     console.log( props.infoList, 'props.infoList====')

//     })
// })
</script>
<script>
export default {
    name: 'designRequirement'
}
</script>
<style lang="scss" scoped>
 .design-requirement{
    margin-bottom: 16px;
    .view-image{
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #5587FF;
      cursor: pointer;
    }
    .design-text{
        display: flex;
        justify-content: space-between;
    }
    .title-box {
    display: flex;
    align-items: center;

    .title-icon {
      width: 5px;
      height: 16px;
      background: #5587FF;
      margin-right: 8px;
    }

    .title-text {
      font-size: 16px;
      font-weight: 700;
      line-height: 22.4px;
      color: #2C364E;
    }
  }
  }
.design-requirement-container{
    font-family: 'Alibaba PuHuiTi 2.0';
    .requirement-main{
        padding: 16px 16px 0 16px;
        border-radius: 6px;
        margin-top: 16px;
        background: rgba(247, 248, 250, 1);
        .params-container{
            display: inline-flex;
            // display: inline-block;
            width: 19%;
            margin-bottom: 14px;
            margin-right: 1%;
            max-width: 19%;
            &:nth-child(5n){
                margin-right: 0 !important;
            }
        }
        .params-div{
            // display: flex;
            // flex-direction: column;
            width: 100%;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            .params-label{
                margin-bottom: 4px;
                white-space: nowrap;
                overflow: hidden;
                color: #737E99;
                text-overflow: ellipsis;
            }
            .params-value{
                word-break: break-word;
                color: #2C364E;
            }
        }
    }
    .target-tooth{
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #2C364E;
        margin-bottom: 14px;
    }
}
</style>